import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b700274&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b700274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b700274')) {
      api.createRecord('4b700274', component.options)
    } else {
      api.reload('4b700274', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b700274&scoped=true", function () {
      api.rerender('4b700274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logModule/apiLog/index.vue"
export default component.exports